import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { CheckoutPageId } from 'checkout/constants/pages'

export const MOBILE_APP_LIKE_CHECKOUT_STEP_LABEL = {
  review: 'mobile-app-like-checkout-step-review',
  payment: 'mobile-app-like-checkout-step-payment',
} as const

export function useMobileAppLikeCheckoutStepLabels(): Record<string, string> {
  const intl = useIntl()

  return useMemo(() => ({
    [MOBILE_APP_LIKE_CHECKOUT_STEP_LABEL.review]: intl.formatMessage({
      id: 'a6KLniHQOVFk1zB_aE8X',
      defaultMessage: 'Secure checkout',
      description: 'Checkout step label for reviewing the booked escape in the mobile app-like checkout experiment',
    }),
    [MOBILE_APP_LIKE_CHECKOUT_STEP_LABEL.payment]: intl.formatMessage({
      id: 'UmdB25uex5h24MxaOgGr',
      defaultMessage: 'Secure checkout',
      description: 'Checkout step label for payment in the mobile app-like checkout experiment',
    }),
  }), [intl])
}

export const MOBILE_APP_LIKE_CHECKOUT_HEADER_STEPS: Array<App.Checkout.CheckoutStep> = [
  {
    label: MOBILE_APP_LIKE_CHECKOUT_STEP_LABEL.review,
    key: CheckoutPageId.Review,
    subSteps: [],
    isRoute: true,
  },
]

export function getMobileAppLikeCheckoutPaymentStep(step: App.Checkout.CheckoutStep): App.Checkout.CheckoutStep {
  return {
    ...step,
    key: CheckoutPageId.Payment,
    label: MOBILE_APP_LIKE_CHECKOUT_STEP_LABEL.payment,
  }
}

export function splitMobileAppLikeCheckoutPurchaseStep(
  steps: Array<App.Checkout.CheckoutStep>,
  isMobileAppLikeCheckoutEnabled: boolean,
): Array<App.Checkout.CheckoutStep> {
  if (!isMobileAppLikeCheckoutEnabled) {
    return steps
  }

  const purchaseStepIndex = steps.findIndex(step => step.key === CheckoutPageId.Purchase)
  if (purchaseStepIndex === -1) {
    return steps
  }

  // The experiment keeps the existing purchase step behaviour, but splits its header position into
  // review and payment steps with dedicated variant routes.
  return [
    ...steps.slice(0, purchaseStepIndex),
    ...MOBILE_APP_LIKE_CHECKOUT_HEADER_STEPS,
    getMobileAppLikeCheckoutPaymentStep(steps[purchaseStepIndex]),
    ...steps.slice(purchaseStepIndex + 1),
  ]
}
